module.exports = __webpack_public_path__ + "static/media/smartobject_original.359b954a.png";